module.exports = __webpack_public_path__ + "img/137.6a969bb6.png";